
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"58","height":"58","viewBox":"0 0 58 58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"58","height":"58","rx":"29","fill":"#D3C9FA"}}),_c('path',{attrs:{"d":"M20.019 23.914l-.05.029v10.076L15 36.964v-15.97l.05-.028 4.969 2.948zM28.575 39.02v5.896l-.1.06L15 36.983v-.019l4.97-2.944v.015l8.505 5.045.1-.06z","fill":"#A793F6"}}),_c('path',{attrs:{"d":"M41.949 36.924v.06l-13.374 7.933V39.02l8.404-4.986v-.06l4.97 2.949z","fill":"#A793F6"}}),_c('path',{attrs:{"d":"M41.949 20.998v15.925l-4.97-2.948V23.943l4.97-2.945z","fill":"#A793F6"}}),_c('path',{attrs:{"d":"M41.949 20.995v.003l-4.97 2.945-8.404-4.987V13.06l13.374 7.935z","fill":"#A793F6"}}),_c('path',{attrs:{"d":"M28.575 13.06v5.896l-.1-.06-8.456 5.018-4.97-2.948L28.476 13l.1.06z","fill":"#A793F6"}})])
          )
        }
      }
    